module.exports = __webpack_public_path__ + "img/full6-min.7d306202.png";